// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + "didi-unify-bridge" + "." + "9ba406fd946ad57b9723" + ".js";
};